/**
 * ovidSignInCard — Ovid's own surface on the shared sign-in card (`@core/auth-ui/SignInCard`, plan
 * `2026_09_17_ovid_one_wall.md` § Decided 6). The mark, the two lines the veiled wall's own panel
 * already carried, and this house's policy pages. Everything else the card says and does is the
 * shared component's, which is the point: Ovid's panel had no inline email validation, no error
 * banner and no sent state, and now has all three without a second implementation.
 */
import {Oculus} from '@product/ovid/components/Oculus/Oculus'

export const OVID_SIGN_IN_CARD = {
    glyph: {mark: <Oculus size={42} />},
    copy: {
        title: 'Sign in to see everything.',
        subtitle: 'Every picture, every muse, and your own.',
    },
    termsHref: '/terms',
    privacyHref: '/privacy',
}
